import api from "@/api";

export default class AuthApi {
  static async Login(data: { id: string; password: string }) {
    return await api.post(`auth/login`, data);
  }

  static async SendCode() {
    return await api.post(`auth/sms`, {
      // phone: "01044795426",
      phone: "01046180250",
    });
  }

  static async Auth(code: string) {
    return await api.post(`auth/sms/check`, {
      code: code,
      // phone: "01044795426",
      phone: "01046180250",
    });
  }
}
